<template>
  <v-text-field class="input-equity-amount" :value="valueStr" @blur="onBlur" v-bind="$attrs" :error="!!error"
    :readonly="isInfinite" placeholder=" ">
    <template #prepend-inner>
      <div class="prepend-wrapper">
        <v-select dense hide-details full-width :value="prependValue" @input="onPrependInput" :items="prependOptions"
          :readonly="disableInfinite" />
      </div>
    </template>
    <template #append>
      <v-tooltip bottom :disabled="!hasHelp">
        <template v-slot:activator="{ on, attrs }">
          <div class="append-wrapper" v-bind="attrs" v-on="on">
            <v-icon v-if="hasHelp">mdi-help-circle-outline</v-icon>
          </div>
        </template>
        <span>
          单位: d=天, h=小时, m=分钟, s=秒
        </span>
      </v-tooltip>
    </template>
  </v-text-field>
</template>

<script>
import { formatAmount, parseDuration } from '@/plugins/duration'
import { isInfinite, AMOUNT_INFINITE, INFINITE_TEXT } from '@/plugins/balance'
import { EquityPattern } from '@/plugins/payment'
import _ from 'lodash'

const OPTION_LIMITED = 'OPTION_LIMITED'
const OPTION_INFINITE = 'OPTION_INFINITE'

export default {
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    pattern: {
      type: Number,
      required: true,
    },
    value: {
      type: Number,
      required: false,
    },
    disableInfinite: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      error: null,
      updated: false,
      oldValue: null,
    }
  },
  mounted() {
    if (!isInfinite(this.value)) {
      this.oldValue = this.value
    }
  },
  computed: {
    isInfinite() {
      return isInfinite(this.value)
    },
    isSubscription() {
      return this.pattern !== EquityPattern.CONSUMABLE
    },
    hasHelp() {
      return this.isSubscription && !this.isInfinite
    },
    prependOptions() {
      let name = this.isSubscription ? '时长' : '数量'
      let result = [
        {
          text: `固定${name}`,
          value: OPTION_LIMITED,
        },
      ]
      if (!this.disableInfinite) {
        result.push({
          text: `无限${name}`,
          value: OPTION_INFINITE,
        })
      }
      return result
    },
    prependValue() {
      if (this.disableInfinite) {
        return OPTION_LIMITED
      }
      return this.isInfinite ? OPTION_INFINITE : OPTION_LIMITED
    },
    valueStr() {
      let value = this.updated ? 0 : this.value
      return formatAmount({ pattern: this.pattern, amount: value })
    },
  },
  methods: {
    emitValue(value) {
      if (!isInfinite(value)) {
        this.oldValue = value
      }
      if (isInfinite(value)) {
        value = AMOUNT_INFINITE
      }
      this.$emit('input', value)
      // 确保触发输入框内容更新
      this.updated = true
      this.$nextTick(() => {
        this.updated = false
      })
    },
    onPrependInput(value) {
      if (value === OPTION_INFINITE) {
        this.emitValue(AMOUNT_INFINITE)
      } else {
        this.emitValue(this.oldValue)
      }
    },
    onBlur(event) {
      let value
      let valueStr = event.target.value
      if (valueStr === INFINITE_TEXT) {
        return
      }
      if (this.isSubscription) {
        value = parseDuration(valueStr)
        if (valueStr && _.isNil(value)) {
          this.error = 'invalid duration'
          return
        }
      } else {
        if (valueStr) {
          value = _.parseInt(valueStr)
          if (_.isNaN(value) || value < 0) {
            this.error = 'invalid number'
            return
          }
        } else {
          value = null
        }
      }
      this.error = null
      this.$emit('blur', event)
      this.emitValue(value)
    },
  },
}
</script>

<style lang="less" scoped>
.input-equity-amount {
  position: relative;

  & /deep/ .v-input__prepend-inner {
    padding: 0;
    margin: 0;
  }

  & /deep/ .v-input__append-inner {
    padding: 0;
    margin: 0;
  }

  & /deep/ input {
    padding-left: 108px;
  }
}

.prepend-wrapper {
  position: absolute;
  z-index: 6;
  width: 104px;

  & /deep/ .v-select {
    margin-top: 0;

    .v-input__slot {
      min-height: 32px !important;
      height: 32px;
    }

    .v-input__slot::before {
      display: none;
    }

    .v-input__append-inner {
      margin-top: 4px !important;
    }
  }
}

.append-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 32px;
  padding-left: 16px;
  padding-right: 4px;
}
</style>
